// extracted by mini-css-extract-plugin
export default {"card":"card--w_ZuUL8h"};